import { Routes } from '@angular/router';
import { ReportsList } from './pages/report-list/reports-list';
import { ReportRunPage } from './pages/report-run-page/report-run-page';
import { featureGuard } from '@fry-it/risr-core';

export const reportRoutes: Routes = [
    {
        path: '',
        canActivate: [featureGuard],
        data: {
            feature: 'reporting'
        },
        children: [
            {
                path: '',
                component: ReportsList,
                title: $localize`Reports`,
            },
            {
                path: 'run/:reportId',
                component: ReportRunPage,
                title: $localize`Run report`,
            }
        ]
    }
];
